import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/student-book-report/StudentBookReportAction";
import { BookReportType, BookReportTypeOptions, CustomSelect, FilterOptions, redirectToPages } from "../../../../../_helpers/Helpers";
import { 
  Card,
  CardBody,
  CardHeader,
  ModalProgressBar
} from "../../../../../_metronic/_partials/controls";
import { StandardReportPage } from "./standard-report/StandardReportPage";
import { BookAndPageNumberPage } from "./book-and-page-number/BookAndPageNumberPage";
import { MonthlyReportPage } from "./monthly-report/MonthlyReportPage";

export function StudentBookReportPage() {
  const [term, setTerm] = useState(0);
  const [date, setDate] = useState("");
  const [dateEnd, setDateEnd] = useState("");
  const [sectionId, setSectionId] = useState();
  const [studentId, setStudentId] = useState();
  const [reportType, setReportType] = useState();

  // Getting curret state of UserAssignment from store (Redux)
  const dispatch = useDispatch();
  const { currentActiveTerm, actionsLoading, isSuccess, type, sections, students } = useSelector(
    (state) => ({
      currentActiveTerm: state.auth.user.currentActiveTerm,
      actionsLoading: state.studentBookReport.actionsLoading,
      isSuccess: state.studentBookReport.isSuccess,
      type: state.studentBookReport.type,
      sections: state.studentBookReport.sections,
      students: state.studentBookReport.students
    }),
    shallowEqual
  );
  
  useEffect(() => {
    setTerm(currentActiveTerm);
    dispatch(actions.getSections());
    return () => dispatch(actions.cleanStudentsState());
  }, [currentActiveTerm, dispatch]);

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  const sectionOptions = FilterOptions.concat(sections);
  const studentOptions = FilterOptions.concat(students);
  
  return (
    <>
      <Card>
        {actionsLoading && <ModalProgressBar />}
        <CardHeader title="Öğrenci Kitap Raporu" />
        <CardBody>
          <div className="form-group row">
            <div className="col-2"></div>
            <div className="col-2 mt-3">
              Dönem
            </div>
            <div className="col-2">
              <input
                type="number"
                className="form-control"
                min={1}
                value={term}
                placeholder="Dönem"
                onChange={e => setTerm(parseInt(e.target.value))}
              />
            </div>
            <div className="col-2">
              <input className="form-control" value={term ? term + 1 : ""} readOnly />
            </div>
          </div>

          <div className="form-group row">
            <div className="col-2"></div>
            <div className="col-2 mt-3">
              Tarih
            </div>
            <div className="col-2">
              <input
                type="date"
                value={date}
                className="form-control"
                placeholder="Başlangıç"
                onChange={e => setDate(e.target.value)}
              />
            </div>
            <div className="col-2">
              <input
                type="date"
                value={dateEnd}
                className="form-control"
                placeholder="Bitiş"
                onChange={e => setDateEnd(e.target.value)}
              />
            </div>
          </div>

          <div className="form-group row">
            <div className="col-2"></div>
            <div className="col-2 mt-3">
              Şube
            </div>
            <div className="col-4">
              <CustomSelect
                options={sectionOptions}
                value={sectionId}
                onChange={option => {
                  dispatch(actions.cleanStudentsState());
                  if (option.value) dispatch(actions.getStudents(term, option.value));
                  setSectionId(option.value);
                  setStudentId(undefined);
                }}
              />
            </div>
          </div>

          <div className="form-group row">
            <div className="col-2"></div>
            <div className="col-2 mt-3">
              Öğrenci
            </div>
            <div className="col-4">
              <CustomSelect
                options={studentOptions}
                value={studentId}
                onChange={option => setStudentId(option.value)}
              />
            </div>
          </div>

          <div className="form-group row">
            <div className="col-2"></div>
            <div className="col-2 mt-3">
              Rapor
            </div>
            <div className="col-4">
              <CustomSelect
                options={BookReportTypeOptions}
                onChange={option => setReportType(option.value)}
              />
            </div>
          </div>
        </CardBody>
      </Card>
      {
        reportType === BookReportType.Standard &&
        <StandardReportPage
          term={term}
          date={date}
          dateEnd={dateEnd}
          sectionId={sectionId}
          studentId={studentId}
        />
      }
      {
        reportType === BookReportType.BookAndPageNumber &&
        <BookAndPageNumberPage
          term={term}
          date={date}
          dateEnd={dateEnd}
          sectionId={sectionId}
          studentId={studentId}
        />
      }
      {
        reportType === BookReportType.Monthly &&
        <MonthlyReportPage
          term={term}
          date={date}
          dateEnd={dateEnd}
          sectionId={sectionId}
          studentId={studentId}
        />
      }
    </>
  );
}